import { Utils } from '../../../providers/utils';
import { RecipeBoxDataGateway } from './recipe-box-data-gateway';
import { Injectable } from '@angular/core';
import { FirebaseStorage } from '../../../providers/firebase-storage';
import { FireBaseObjectNames } from '../../../core/codes';
import { AppSettings } from '../../../config/app-settings';
import { Storage } from '@ionic/storage';
import firebase from 'firebase';
//import { Utils } from '../../../providers/utils';
import { ElasticSearchService } from '../../../providers/elastic-search';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeAll';

@Injectable()
export class RecipeData {
    public realtimeDb: any;
    private elasticSearch: any;
    //private userRecipes = [];
    private recipesNode = 'recipes';
    constructor(
        private firebaseStorage: FirebaseStorage,
        public settings: AppSettings,
        private storage: Storage,
        public elasticSearchService: ElasticSearchService,
        public afw: AngularFireDatabaseWrapper,
        public recipeBoxDataGateway: RecipeBoxDataGateway
    ) {
        this.realtimeDb = firebase.database();
        if (!this.settings.elasticSearch || !this.settings.elasticSearch.config || !this.settings.elasticSearch.config.host) {
            this.settings.getData().subscribe(sets => {
                this.elasticSearch = this.settings.elasticSearch[this.recipesNode];
            });
        }
        else {
            this.elasticSearch = this.settings.elasticSearch[this.recipesNode];
        }
    }
    public getRecipesFullData(categoryId,keyword, userId, pageSize, pageIndex) {
        return this.searchQuery(categoryId,keyword, pageSize, pageIndex,true).map((recipesResult: any) => {
            return this.injectUserRecipeData(recipesResult.items, userId).map(result=>{
                return recipesResult;
    });
        }).mergeAll();

    }
    public getRecipeDetail(uid, recipeId) {
        let strgRef = FireBaseObjectNames.RECIPES + '/' + recipeId;
        return this.afw.object(strgRef, undefined, true).map(recipe => {
            return this.injectUserRecipeData(recipe, uid).map(injectedRecipe => {
                return injectedRecipe = injectedRecipe[0];
            });
        }).mergeAll();

    }

    public injectUserRecipeData(recipes, userId) {
        return this.recipeBoxDataGateway.getService(userId).getUserRecipes(userId).map((userRecipes: any) => {
            userRecipes = Utils.toAngularFireArray(userRecipes).reverse();
            if (recipes.constructor !== Array) {
                recipes = [recipes];
            }
            _.forEach(recipes, recipe => {
                let urecipe = _.find(userRecipes, (userRecipe: any) => { return userRecipe.$key == recipe.$key || userRecipe.$key == recipe.$id });
                if (urecipe) {
                    recipe.isFavorite = true;
                }
                else {
                    recipe.isFavorite = false;
                }
            });
            return recipes;
        });
    }
    public getAllCategories() {
        let strgRef = FireBaseObjectNames.RECIPE_CATEGORIES;
        var result = this.afw.list(strgRef).map(val => {
            this.storage.set(strgRef, JSON.stringify(val));
            return val;
        });
        return result;
    }

    public updateTimeStampModified(ref) {
        let timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
        return this.afw.object(ref).update({ timestampModified: timeStamp });
        // .then((result) => {
        //     console.log(result);
        //     let storageKey = 'strg:' + ref;
        //     let unixtime = new Date().getTime();
        //     console.log(unixtime);
        //     return this.updateTimeStampModifiedLocal(storageKey, unixtime);
        // });
    }
    // public updateTimeStampModifiedLocal(ref, timeStamp) {
    //     let self = this;
    //     return this.storage.get(ref).then(function (value) {
    //         if (!value) {
    //             return;
    //         }
    //         var result = JSON.parse(value);
    //         console.log(ref);
    //         result['timestampModified'] = timeStamp;
    //         console.log(JSON.parse(JSON.stringify(result)));
    //         return self.storage.set(ref, JSON.stringify(result));
    //     });
    // }
    public searchByCategory(term, pageSize, pageIndex) {
        // console.log('--------searchRecipesByCategory');
        var size = parseInt(pageSize);
        var currentPage = parseInt(pageIndex);
        var from = size * currentPage;
        // if (from > 0) {
        //     from = from - 1;
        // }

        //create query
        var query: any = {
            index: this.elasticSearch.index,
            type: this.elasticSearch.type,
            size: size,
            from: from
        };
        if (term && term != null && term.trim() === '' || term === 'All') {
            query.body = {};
            query.body.query = {
                bool: {
                    must: {
                        match_all: {}
                    }
                }
            };
        } else {
            query.body = {};
            query.body.query = {
                bool: {
                    must: {
                        exists: {
                            "field": "categories." + term
                        }
                    }
                    // },
                    // must_not:{
                    //     match:
                    //     {
                    //         tags: 'Appetizer'
                    //     }
                    // }

                }
            };
        }
        // if (sort) {
        //     query.sort = sort + ':desc';
        // }
        return this.elasticSearchService.Search(query, this.elasticSearch.path, false).map(result => {
            return result;
        });
    }
    public searchQuery(cateId, term, pageSize, pageIndex, sort) {
        term = !term ? '' : term.trim();
        var size = parseInt(pageSize);
        var currentPage = parseInt(pageIndex);
        var from = size * currentPage;
        from = pageSize * pageIndex;
        // if (from !== 0) {
        //     from = from - 1;
        // }

        //create query
        var query : any={
            index: this.elasticSearch.index,
            type: this.elasticSearch.type,
            size: size,
            from: from
        };
        console.log(cateId,term);
        if ((!cateId || cateId === '' || cateId === 'All') && term === '') {
            query.body = {};
            query.body.query = {
                bool: {
                    must: [{
                        match_all: {}
                    }],
                    must_not: {
                        match: {
                            isDeleted: true
                        }
                    }
                }
            };
        } else if (cateId && cateId !== '' && cateId !== 'All' && term === '') {
            query.body = {};
            query.body.query = {
                bool: {
                    must: [
                        {
                            exists: {
                                field: "categories." + cateId
                            }
                        }
                    ],
                    must_not: {
                        match: {
                            isDeleted: true
                        }
                    }
                }
            };
        } else if (cateId && cateId !== '' && cateId !== 'All' && term !== '') {
            query.body = {};
            query.body.query = {
                bool: {
                    must: [
                        {
                            exists: {
                                field: "categories." + cateId
                            }
                        },
                        {
                            bool: {
                                should: [
                                    {
                                        multi_match: {
                                            query: term,
                                            type: "phrase_prefix",
                                            fields: ["title", "description"]
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    must_not: {
                        match: {
                            isDeleted: true
                        }
                    }
                }
            };
        } else if ((!cateId || cateId === '' || cateId === 'All') && term !== '') {
            query.body = {};
            query.body.query = {
                bool: {
                    must: [
                        {
                            bool: {
                                should: [
                                    {
                                        multi_match: {
                                            query: term,
                                            type: "phrase_prefix",
                                            fields: ["title", "description"]
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    must_not: {
                        match: {
                            isDeleted: true
                        }
                    }
                }
            };
        }

        // if (sort) {
        //     query.sort = sort + ':desc';
        // }
        return this.elasticSearchService.Search(query, this.elasticSearch.path, false).map(result => {
            return result;
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/recipes/providers/recipe-data.ts